import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { UploadStatus } from 'components/UploadStatus';
import { useMethodsConfirmationDialog } from 'hooks/useMethodsConfirmationDialog';
import { Button } from 'uikit';

import type React from 'react';
import { useCallback, useState } from 'react';

import { AddWorkOrderChangeFromXmlModal } from './AddWorkOrderChangeFromXmlModal';

interface IAddWorkOrderChangeFromXml {
    workOrderChangeId: number;
    contractId: number;
    disabled: boolean;
    refresh: () => void;
}
export const AddWorkOrderChangeFromXml: React.FC<IAddWorkOrderChangeFromXml> = (props) => {
    const { workOrderChangeId, contractId, disabled, refresh } = props;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

    const { isOpenConfirmationDialog, handleOpenConfirmationDialog, handleCloseConfirmationDialog, handleActionQuery } =
        useMethodsConfirmationDialog({
            actionFn: () => setIsModalOpen(false),
        });

    const onModalOpenClick = useCallback(() => {
        setIsModalOpen(true);
    }, []);

    const onClose = useCallback(
        (isSuccess?: boolean, hasChanges?: boolean) => {
            if (isSuccess) {
                setIsModalOpen(false);
                setIsSuccessModalOpen(true);
            } else if (hasChanges) {
                handleOpenConfirmationDialog();
            } else {
                setIsModalOpen(false);
            }
        },
        [handleOpenConfirmationDialog],
    );

    const onSuccessModalClose = useCallback(() => {
        setIsSuccessModalOpen(false);
        refresh();
    }, [refresh]);

    return (
        <>
            <Button label="Добавить ВОР" size="s" view="secondary" onClick={onModalOpenClick} disabled={disabled} />
            {isModalOpen && (
                <AddWorkOrderChangeFromXmlModal
                    workOrderChangeId={workOrderChangeId}
                    onClose={onClose}
                    contractId={contractId}
                />
            )}
            <UploadStatus
                isOpened={isSuccessModalOpen}
                handleCloseModal={onSuccessModalClose}
                statusText="Проверка завершена. Ошибок не обнаружено."
                titleText="Загрузка ведомости объемов работ"
                status="success"
                withTitleCloseButton={false}
            >
                <Button label="Перейти в Изм. к НЗ" onClick={onSuccessModalClose} />
            </UploadStatus>
            <ConfirmationDialog
                isOpened={isOpenConfirmationDialog}
                onSubmit={handleActionQuery}
                onClose={handleCloseConfirmationDialog}
                textHeader="Отмена действия"
                textConfirmation="Вы уверены, что хотите отменить? Данные не будут сохранены"
                cancelButtonText="Не отменять"
                confirmButtonText="Отменить "
            />
        </>
    );
};

AddWorkOrderChangeFromXml.displayName = 'AddWorkOrderChangeFromXml';
